module.exports = __webpack_public_path__ + "static/media/icon-target-segment.35d02c96.svg";